import { Validators } from '@angular/forms';
import { ActionInterface, ACTIONS_BASE } from './actions.constants';
import { ColumnNames, FormField } from './form.constants';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from '../utils/paginate.utils';

export const ESTABLECIMIENTOS_FIELDS_FORM: {[name: string]: FormField} = {
  descripcion: {
    type: 'text',
    label: 'Descripción',
    validations: [Validators.required],
    position: 1,
    placeholder: 'Nombre del establecimiento',
  },
  cod_distrito: {
    type: 'text',
    label: 'Distrito',
    validations: [Validators.required],
    position: 2,
    placeholder: 'ID del distrito',
  },
  residencia: {
    type: 'text',
    label: 'Residencia',
    validations: [Validators.required],
    position: 3,
  },
  modalidad_id: {
    type: 'select',
    label: 'Modalidad',
    validations: [Validators.required],
    position: 4,
    placeholder: 'Modalidad',
  },
};

export const ESTABLECIMIENTOS_COLUMN_NAMES: ColumnNames[] = [
  { name: 'id', label: 'ID' },
  { name: 'descripcion', label: 'Descripción' },
  { name: 'cod_distrito', label: 'Distrito' },
  { name: 'residencia', label: 'Residencia' },
  { name: 'modalidad.descripcion', label: 'Modalidad' },
  { name: 'observacion', label: 'Observación' },
  { name: 'created_at', label: 'Fecha Alta', pipe: 'date' },
  { name: 'deleted_at', label: 'Fecha Baja', pipe: 'date' },
];
export const ESTABLECIMIENTOS_COLUMN_NAMES_DETAILS: ColumnNames[] = [
  { name: 'id', label: 'ID' },
  { name: 'cod_distrito', label: 'Distrito' },
  { name: 'descripcion', label: 'Descripción' },
  { name: 'residencia', label: 'Residencia' },
  { name: 'modalidad.descripcion', label: 'Modalidad' },
  { name: 'observacion', label: 'Observación' },
];

// export const ESTABLECIMIENTOS_ACTIONS: ActionButton[] = [
//   { type: 'view', label: 'Ver', icon: 'visibility' },
//   { type: 'edit', label: 'Editar', icon: 'edit' },
//   { type: 'delete', label: 'Eliminar', icon: 'delete' },
// ];

export const ESTABLECIMIENTOS_ACTIONS : {[name:string]:ActionInterface}=
  {
    ...ACTIONS_BASE
}
export const ESTABLECIMIENTOS_PAGINATE_OPTIONS:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
}
